import { useCollapsibleStore } from '@stores/useCollapsibleStore'

export function useCollapsibleToggle() {
  const isCollapsibleOpen = useCollapsibleStore((state) => state.isOpen)
  const setCollapsibleOpen = useCollapsibleStore((state) => state.setIsOpen)

  const toggleCollapsible = () => {
    setCollapsibleOpen(!isCollapsibleOpen)
  }

  return { isCollapsibleOpen, toggleCollapsible }
}
